Vue.asyncComponent('ak-items-per-page', {
    data() {
        return {
            currentItemsPerPage: this.pageJumper.countPerPage
        }
    },
    props: {
        pageJumper: {
            type: Object,
            required: true,
            default: {}
        },
        itemsPerPageOptions: {
            type: Array,
            required: true
        }
    },
    watch: {
        currentItemsPerPage( ) {
            this.$emit('setItemsPerPage', this.currentItemsPerPage);
        }
    }
}, 'grid/layout/ak-items-per-page.html');
